import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import type { QuizWho, QuizDietPreference } from "./types";

export interface QuizStepVeganVegetarianProps {
  who: QuizWho | "";
  value: QuizDietPreference;
  onChange: (d: QuizDietPreference) => void;
  error: string | null;
  assetUrl: string;
  onNext: () => void;
}

const OPTIONS: {
  value: QuizDietPreference;
  label: string;
  icon: string;
  iconHover: string;
}[] = [
  {
    value: "vegan",
    label: "Vegan",
    icon: "BF_Quiz_Icon_Vegan_white.svg",
    iconHover: "BF_Quiz_Icon_Vegan.svg",
  },
  {
    value: "vegetarian",
    label: "Vegetarian",
    icon: "BF_Quiz_Icon_Vegetarian_white.svg",
    iconHover: "BF_Quiz_Icon_Vegetarian.svg",
  },
  {
    value: "",
    label: "No",
    icon: "BF_Quiz_Icon_no_white.svg",
    iconHover: "BF_Quiz_Icon_no.svg",
  },
];

export const QuizStepVeganVegetarian: React.FC<
  QuizStepVeganVegetarianProps
> = ({ who, value, onChange, error, assetUrl, onNext }) => {
  const title =
    who === "your"
      ? "Are you vegan or vegetarian?"
      : "Are they vegan or vegetarian?";

  const handleChange = (v: QuizDietPreference) => {
    onChange(v);
    onNext();
  };

  return (
    <motion.li
      className="step"
      data-step="vegan_vegetarian"
      initial={{ opacity: 0, x: 24 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -24 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      <div className="quiz-inner">
        <div className="quiz-title" data-question-type="title">
          <h2>{title}</h2>
        </div>
        <div data-question-type="tags">
          <ol className="quiz-cards quiz-cards--tags">
            {OPTIONS.map((opt) => (
              <li
                key={opt.label}
                className={`quiz-card-radio ${value === opt.value ? "selected" : ""}`}
              >
                <label
                  htmlFor={`step-vegan_vegetarian-radio-${opt.label.toLowerCase()}`}
                >
                  <input
                    type="radio"
                    id={`step-vegan_vegetarian-radio-${opt.label.toLowerCase()}`}
                    name="quiz-step-vegan-vegetarian"
                    value={opt.value}
                    checked={value === opt.value}
                    onChange={() => handleChange(opt.value)}
                  />
                  <div
                    className="quiz-box"
                    style={{ backgroundImage: `url('${assetUrl}${opt.icon}')` }}
                  >
                    <div
                      className="quiz-box--hover"
                      style={{
                        backgroundImage: `url('${assetUrl}${opt.iconHover}')`,
                      }}
                    />
                  </div>
                  <div>{opt.label}</div>
                </label>
              </li>
            ))}
          </ol>
        </div>
        <AnimatePresence mode="wait">
          {error && (
            <motion.div
              key={error}
              className="quiz-error"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -4 }}
              transition={{ duration: 0.2, ease: "easeOut" }}
            >
              {error}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.li>
  );
};
